module.exports = __webpack_public_path__ + "static/media/cftitle.8ce89d57.png";